import { render, staticRenderFns } from "./HistoricDebits.vue?vue&type=template&id=407dedcb"
import script from "./HistoricDebits.vue?vue&type=script&lang=js"
export * from "./HistoricDebits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports